import { createRouter, createWebHashHistory } from "vue-router";
import Dashboard from "@/views/Dashboard.vue";
//import Tables from "@/views/Tables.vue";
import Statistic from "@/views/statistic/Statistic.vue"
import Devices from "@/views/devices/Devices.vue"
import MerchantList from "@/views/merchants/MerchantList.vue"
import MerchantDetail from "@/views/merchants/MerchantDetail.vue"
import UserList from "@/views/users/UserList.vue"
import AdministratorsTable from "@/views/administrators/AdministratorsTable.vue";
import Submission from "@/views/submission/Submission.vue";
import SubUsers from "@/views/merchants/subusers/SubUsers.vue";
import Profile from "@/views/profile/Profile.vue";
import SignIn from "@/views/SignIn.vue";
import NotFound from "@/views/NotFound.vue"; 
import InitBoardWhitelist from "@/views/initboard/InitBoardWhitelist.vue";
import ShopList from "@/views/shops/ShopList.vue";
import OperatorLogs from "@/views/operatorlogs/OperatorLogs.vue";
import store from '@/store';
import { getToken } from '@/utils/auth';

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: '/login',
    component: SignIn,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/users",
    name: "Users",
    component: UserList,
  },
  {
    path: "/mechants",
    name: "Merchants",
    component: MerchantList,
  },
  {
    path: "/merchants/:id",
    name: "MerchantDetail",
    component: MerchantDetail,
  },
  {
    path: "/subusers",
    name: "SubUsers",
    component: SubUsers,
  },
  {
    path: "/submission",
    name: "Submission",
    component: Submission,
  },
  {
    path: "/statistic",
    name: "Statistic",
    component: Statistic,
  },
  {
    path: "/devices",
    name: "Devices",
    component: Devices,
  },
  {
    path: "/shops",
    name: "Shops",
    component: ShopList,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/administrators",
    name: "Administrators",
    component: AdministratorsTable,
  },
  {
    path: '/logout',
    name: 'Logout',
    component:SignIn,
  },
  {
    path: "/initboard",
    name: "InitBoard",
    component: InitBoardWhitelist,
  },
  {
    path: "/operator-logs",
    name: "OperatorLogs",
    component: OperatorLogs,
  },
  {
    path: "/:catchAll(.*)",  // 捕获所有未知路径
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// 路由守卫：检查用户是否已登录
router.beforeEach((to, from, next) => {
  console.log("get token:", store.getters.token, "frompath:", from.path, "topath:", to.path)
  if (!store.getters.token && to.path != '/login' && to.path != '/profile') {
    console.log("get token false:", !store.getters.token)
    next('/login');  // 如果未登录，重定向到登录页
  } else {
    // 进件管理仅限手机号登录的特殊账号访问，CS 平台账号无论权限设置均不可访问
    if (to.path === '/submission') {
      const token = getToken();
      if (!token || token.is_special !== 1) {
        console.log("[ROUTER] non-special account blocked from /submission");
        next('/dashboard');
        return;
      }
    }
    console.log("Token found, proceeding to:", to.path);
    next();  // 允许访问
  }
});


export default router;
